import * as angular from 'angular';
import * as moment from 'moment';

import { refreshClick, dateFormatShort, wideService } from '../../../common';
import { IDateRangeService, IHistoryService, IStoreService } from '../../../services';
import { ApplicationUserViewModel, ComponentDefinition, DataTransactionDto, DataTransactionViewModel, IStringDateRange2 } from '../../../models';
import { StoreElement, Store } from '../../../stateManagement';

class DataTransactionsStateController implements angular.IComponentController {
    beginDate: string;
    dateFormat = dateFormatShort;
    endDate: string;
    initialRange: IStringDateRange2;
    isLoaded: boolean;
    isLoading: boolean;
    loadingMessage: string;
    selectedItem: DataTransactionViewModel;
    transactions: DataTransactionViewModel[];
    userViewModels: { [guid: string]: ApplicationUserViewModel };

    private _garbages: (() => void)[] = [];

    static $inject = [
        '$scope',
        '$translate',
        '$stateParams',
        'historyService',
        'storeService',
        'dateRangeService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$translate: angular.translate.ITranslateService,
        private _$stateParams: angular.ui.IStateParamsService,
        private _historyService: IHistoryService,
        private _storeService: IStoreService,
        private _dateRangeService: IDateRangeService
    ) {
    }

    $onInit() {
        this._dateRangeService.initByState(this._$stateParams);
        this.initialRange = {
            beginDate: this._dateRangeService.beginDate() as string,
            endDate: this._dateRangeService.endDate() as string
        };
        this._garbages.push(this._$scope.$on(refreshClick, () => this.refresh()));
        this._garbages.push(this._$scope.$watchGroup(
            [
                () => this.beginDate,
                () => this.endDate
            ],
            () => this.refresh()));

        this.isLoading = true;
        this._garbages.push(this._storeService.register(
            store => this.refreshStore(store),
            [
                StoreElement.Users
            ]
        ));
    }

    $onDestroy() {
        this._garbages.forEach(g => g());
    }

    private refreshStore(store: Store) {
        this.isLoading = store.users.isLoading;
        this.isLoaded = store.users.isLoaded;
        this.userViewModels = store.users.dictionary;
        this.refresh();
    }

    private refresh() {
        if (this.beginDate && this.endDate && this.isLoaded) {
            this.isLoading = true;
            this.loadingMessage = 'Loading transactions';
            this._historyService
                .getTransactions(this.beginDate, this.endDate)
                .then(data => {
                    this.transactions = data.map(object => this.mapObject(object));
                })
                .finally(() => this.isLoading = false);
        }
    }

    private mapObject(object: DataTransactionDto): DataTransactionViewModel {
        const vm = Object.assign({}, object as DataTransactionViewModel);
        if (object && object.creationUser && this.userViewModels) {
            vm.userViewModel = this.getUserViewModel(vm);
        }
        return vm;
    }

    private getUserViewModel(vm: DataTransactionViewModel): ApplicationUserViewModel {
        let userViewModel: ApplicationUserViewModel;
        if (vm.creationUser === wideService) {
            userViewModel = {
                displayName: wideService,
                firstName: wideService,
                initials: 'WS'
            } as ApplicationUserViewModel;
        } else {
            userViewModel = Object.values(this.userViewModels).find(userViewModel => userViewModel.name === vm.creationUser);
            if (!userViewModel) {
                userViewModel = {
                    displayName: vm.creationUser
                        ? vm.creationUser
                        : this._$translate.instant('Unknown creator'),
                    initials: ''
                } as ApplicationUserViewModel;
                userViewModel.firstName = userViewModel.displayName;
            }
        }
        return userViewModel;
    }
}

export const wtDataTransactionsState: ComponentDefinition = {
    componentId: 'wtDataTransactionsState',
    controller: DataTransactionsStateController,
    template: require('./dataTransactionsState.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};
